import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Unity, useUnityContext } from "react-unity-webgl";
import envConfig from "../config.json";
import { Progress, Radio, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import NavigationMessage from "../components/NavigationMessage";
import { useTheme } from "../components/ThemeContext";
/**
 * Component to manage POI mapping functionality
 */
const PoiMapping = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const {
    unityProvider,
    isLoaded,
    loadingProgression,
    sendMessage,
    unload,
    addEventListener,
  } = useUnityContext({
    loaderUrl: "poimapper/Build/poimapper.loader.js",
    dataUrl: "poimapper/Build/poimapper.data",
    frameworkUrl: "poimapper/Build/poimapper.framework.js",
    codeUrl: "poimapper/Build/poimapper.wasm",
  });

  /* We'll round the loading progression to a whole number to represent the
   percentage of the Unity Application that has loaded. */
  const loadingPercentage = Math.round(loadingProgression * 100);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [disableToggle, setDisableToggle] = useState(false);

  const msalToken = localStorage.getItem("msal.accesstoken");
  const Token3DCE = localStorage.getItem("accesstokence");
  const sasToken = localStorage.getItem("sasToken");
  /**
   * Function to get the cdf token
   */
  const getCdfToken = () => {
    const unityObj = {
      env: envConfig.env,
      middleware_base_url: envConfig.aotmwapi,
      access_token_3dce:
        envConfig.application_type === "couple" ? Token3DCE : "",
      msal_token: msalToken,
      cognite_ah_rootnode: envConfig.cognite_ah_rootnode,
      sas_token: sasToken,
      theme: theme
    };
    const unityJson = JSON.stringify(unityObj);
    console.log({ unityJson });
    sendMessage("HtmlUnityBridge", "OnConfigurationReceived", unityJson);
    setLoading(false);
  };
  /**
   * Function to manage handle click
   * @param {*} evt
   */
  const handleClick = async (evt) => {
    try {
      await unload();
      navigate(evt.detail.pathName, { replace: true });
    } catch (error) {
      console.log({ error });
    }
  };
  /**
   * Function to handle model change
   * @param {*} evt
   */
  const handleModeChange = async (_e) => {
    await unload();
    navigate("/mapper", { replace: true });
  };

  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    if (isLoaded) {
      setLoading(true);
      setDisableToggle(true);
      getCdfToken();      
    }
    addEventListener("raiseEventFromUnity", function (arg1, arg2) {
      if (arg1 === "Unauthorized") {
        console.log("AuthenticationFailLogOut");
        localStorage.removeItem("checkRole");
        const logoutRequest = {
          postLogoutRedirectUri: envConfig.redirectUri,
        };
        instance.logoutRedirect(logoutRequest);
      }
    });

    const handleWindowResize = () => {
      const widthreduced = (window.innerWidth / 100) * 5;
      setWindowWidth(window.innerWidth - widthreduced);
    };
    window.addEventListener("/assetmapper", (evt) => {
      handleClick(evt);
    });
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();

    const setWebGLTheme = () => {
      const theme = localStorage.getItem("TwinBuilder3DTheme");
      sendMessage("HtmlUnityBridge", "OnThemeChange", theme);
    };
    window.addEventListener("SetWebGLTheme", setWebGLTheme);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("SetWebGLTheme", setWebGLTheme);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, loadingPercentage,addEventListener]);

  return (
    <div id="containerFixed">
      <br></br>
      <div className="paddingRow" style={{marginTop: "0px"}}>
        <Radio.Group
          onChange={handleModeChange}
          defaultValue="mapping"
          buttonStyle="solid"
        >
          <Radio.Button
            disabled={!disableToggle}
            value="model"
            className="mapperToggleButton"
          >
            MODEL MAPPING
          </Radio.Button>
          <Radio.Button value="mapping" className="mapperToggleButton">
            POI MAPPING
          </Radio.Button>
        </Radio.Group>
      </div>
      <div>
        {!isLoaded ? (
          <>
            <Progress
              strokeColor={{
                "0%": "#108ee9",
                "100%": "#87d068",
              }}
              percent={loadingProgression * 100}
              showInfo={false}
            />
            <NavigationMessage></NavigationMessage>
          </>
        ) : null}
        <div id="unity-container" className="unity-desktop">
          <Unity
            unityProvider={unityProvider}
            style={{
              visibility: isLoaded ? "visible" : "hidden",
              width: `${windowWidth}px`,
              height: "calc(100vh - 150px)",
              marginTop: "-30px",
            }}
            tabIndex={1}
            devicePixelRatio={devicePixelRatio}
          />
        </div>
        {loading ? (
          <div className="centerPage">
            <div className="divAlignCenter">
              <Spin>
                <p>Loading</p>{" "}
              </Spin>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PoiMapping;
